<template>
  <div class="highlights-container">
    <div class="highlights-container-desktop" :class="highlights_open && 'highlights-container-desktop-open'">
      <div class="highlights-close" v-if="!highlights_open">
        <div class="profile-avatar">
          <img :src="(profileData.profile_img && profileData.profile_img!='0') ? profileData.profile_img : 'https://images.avishkaar.cc/misc/profile/images/default-avatar.png'" class="profile-avatar-img" alt="Avatar" width="60" height="60" />
        </div>
        <div class="profile-name">
          <div class="title" style="text-transform: capitalize">{{ profileData.username }}</div>
          <div class="follower content" v-if="followData && accessProfile">{{followData ? followData.follower.length : '0'}} Followers</div>
          <div class="follower content" v-else-if="followData && loggedIn.username == $route.params.userName">{{followData ? followData.follower.length : '0'}} Followers</div>
          <a class="follower content" :href="`${home}/login`" v-else-if="loggedIn ? (loggedIn.user_id ? false : true) : true">Follow</a>
          <div class="follower content curPoi" @click="Unfollow" v-else-if="(followData && profileData) ? (followData.following.length ? followData.following.some(a=>a.following == profileData.user_id) : false) : false">Unfollow</div>
          <div class="follower content curPoi" @click="Follow" v-else>Follow</div>
        </div>
        <div class="share" @click="openModal=true;share=true;">
          <img src="https://images.avishkaar.cc/misc/profile/share/share-icon.png" alt="Share" />
        </div>
        <div class="dropdown" @click="highlights_open = true">
          <img src="https://images.avishkaar.cc/misc/profile/utility/dropdown-down-icon.png" alt="More" />
        </div>
      </div>
      <div class="highlights-open" v-else>
        <div class="profile-avatar">
          <img :src="(profileData.profile_img && profileData.profile_img!='0') ? profileData.profile_img : 'https://images.avishkaar.cc/misc/profile/images/default-avatar.png'" class="profile-avatar-img" alt="Avatar" width="175" height="175" />
        </div>
        <div class="title" style="text-transform: capitalize">{{ profileData.username }}</div>
          <div class="follower content" v-if="followData && accessProfile">{{followData ? followData.follower.length : '0'}} Followers</div>
          <div class="follower content" v-else-if="followData && loggedIn.username == $route.params.userName">{{followData ? followData.follower.length : '0'}} Followers</div>
          <a class="follower content" :href="`${home}/login`" v-else-if="loggedIn ? (loggedIn.user_id ? false : true) : true">Follow</a>
          <div class="follower content curPoi" @click="Unfollow" v-else-if="(followData && profileData) ? (followData.following.length ? followData.following.some(a=>a.following == profileData.user_id) : false) : false">Unfollow</div>
          <div class="follower content curPoi" @click="Follow" v-else>Follow</div>
        <div class="project-upload">
          <div class="count">{{ projects_data !== null ? projects_data.filter((a)=>(a.is_deleted != 1 && a.is_approved == 1)).length : "0" }}</div>
          <div class="content">Total Project Uploads</div>
        </div>
        <button class="orange-button" @click="openModal=true;share=true;">Share Profile</button>
        <!-- <button class="orange-button white-button">Export Profile ( PDF )</button> -->
        <div class="dropdown" @click="highlights_open = false">
          <img src="https://images.avishkaar.cc/misc/profile/utility/dropdown-up-icon.png" alt="More" />
        </div>
      </div>
    </div>
    <div class="highlights-container-mobile" :style="'background-image: url(' + ((profileData.profile_img && profileData.profile_img!='0') ? profileData.profile_img : 'https://images.avishkaar.cc/misc/profile/images/default-avatar.png') + ');background-size: cover;background-position: center;background-repeat: none;'" @click="highlights_open_mobile=true;openModal=true;" />
    <v-dialog v-model="openModal" width="unset" persistent :fullscreen="$vuetify.breakpoint.width < 700 && true">
      <div class="highlights-container-mobile-open" v-if="highlights_open_mobile">
        <div class="title-container">
          <div class="title">Profile Highlights</div>
          <button style="outline: none" @click="highlights_open_mobile=false;openModal=false;">
            <img src="https://images.avishkaar.cc/misc/profile/utility/cross-icon.png" alt="Close" />
          </button>
        </div>
        <div class="highlights">
          <div class="profile-avatar">
            <img :src="(profileData.profile_img && profileData.profile_img!='0') ? profileData.profile_img : 'https://images.avishkaar.cc/misc/profile/images/default-avatar.png'" class="profile-avatar-img" alt="Avatar" width="175" height="175" />
          </div>
          <div class="title" style="text-transform: capitalize">{{ profileData.username }}</div>
            <div class="follower content" v-if="followData && accessProfile">{{followData ? followData.follower.length : '0'}} Followers</div>
            <div class="follower content" v-else-if="followData && loggedIn.username == $route.params.userName">{{followData ? followData.follower.length : '0'}} Followers</div>
            <a class="follower content" :href="`${home}/login`" v-else-if="loggedIn ? (loggedIn.user_id ? false : true) : true">Follow</a>
            <div class="follower content curPoi" @click="Unfollow" v-else-if="(followData && profileData) ? (followData.following.length ? followData.following.some(a=>a.following == profileData.user_id) : false) : false">Unfollow</div>
            <div class="follower content curPoi" @click="Follow" v-else>Follow</div>
          <div class="project-upload">
            <div class="count">{{ projects_data !== null ? projects_data.filter((a)=>(a.is_deleted != 1 && a.is_approved == 1)).length : "0" }}</div>
            <div class="content">Total Project Uploads</div>
          </div>
        </div>
        <div class="footer-container">
          <!-- <button class="orange-button white-button">Export Profile</button> -->
          <button class="orange-button" @click="highlights_open_mobile=false;share=true;">Share Profile</button>
        </div>
      </div>
      <div class="dialog-share-container" v-if="share">
        <div class="title-container">
          <div class="mobile-title">
            <button style="outline: none" @click="share=false;highlights_open_mobile=true;">
              <img src="https://images.avishkaar.cc/misc/profile/utility/back-icon.png" class="back-icon" alt="Back" />
            </button>
            <div class="mobile-title-item">Share Profile</div>
            <div class="title">Share My Profile</div>
          </div>
          <button style="outline: none" @click="share=false;openModal=false;">
            <img src="https://images.avishkaar.cc/misc/profile/utility/cross-icon.png" alt="Close" width="14" />
          </button>
        </div>
        <div class="share-container">
          <!-- <div class="link-people">
            <v-text-field
              hide-details
              class="input-search"
              :label="focus_active || searchValue ? 'People' : ''"
              @focus="focus_active = true"
              @blur="focus_active = false"
              placeholder="Search for names,alias etc"
              outlined
              v-model="searchValue"
            >
              <template v-slot:prepend-inner v-if="!focus_active && !searchValue">
                <img src="https://images.avishkaar.cc/misc/profile/utility/search-icon.png" alt="Search" width="16" height="16" />
              </template>
            </v-text-field>
          </div>
          <div class="sub-title or">OR</div> -->
          <div class="link-input">
            <v-text-field
              hide-details
              class="input-share"
              label="Link"
              outlined
              v-model="linkValue"
              disabled
            >
            </v-text-field>
          </div>
          <div class="share-via-container">
            <div class="sub-title">Share Via :</div>
            <div class="share-via">
              <div class="share-via-item" v-for="item in share_via" :key="item.id" @click="(item.alt == 'Copy Link' && copyURL(linkValue)) || (item.alt == 'Whatsapp' && whatsappShare(linkValue)) || (item.alt == 'Linkedin' && LinkedInShare(linkValue)) || (item.alt == 'Twitter' && twitterShare(linkValue)) || (item.alt == 'Instagram' && instagramShare(linkValue)) || (item.alt == 'Gmail' && gmailShare(linkValue)) || (item.alt == 'Facebook' && facebookShare(linkValue))">
                <img :src="'https://images.avishkaar.cc/misc/profile/share/' + item.image + '-icon.png'" class="share-via-img" :alt="item.alt" />
                <div class="content">{{ item.alt }}</div>
              </div>
              <div class="share-via-item" v-if="$vuetify.breakpoint.width < 700" @click="contactShare(linkValue)">
                <img src="https://images.avishkaar.cc/misc/profile/share/contacts-icon.png" alt="Contacts" class="share-via-img" />
                <div class="content">Contacts</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="footer-container">
          <button class="orange-button">Export Profile ( PDF )</button>
        </div> -->
      </div>
    </v-dialog>
    <div class="loaderr" v-if="loading"><div class="loader3"><span /><span /></div></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
const BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "https://localhost:3000";
export default {
  name: "Highlights",
  data() {
    return {
      home: process.env.VUE_APP_HOME_URL,
      highlights_open: false,
      highlights_open_mobile: false,
      projects_data: null,
      openModal: false,
      share: false,
      focus_active: false,
      accessProfile: true,
      loading: false,
      searchValue: null,
      linkValue: null,
      share_via: [
        { id: 1, image: "copy", alt: "Copy Link" },
        { id: 2, image: "whatsapp", alt: "Whatsapp" },
        { id: 3, image: "linkedin", alt: "Linkedin" },
        { id: 4, image: "twitter", alt: "Twitter" },
        { id: 5, image: "instagram", alt: "Instagram" },
        { id: 6, image: "gmail", alt: "Gmail" },
        { id: 7, image: "facebook", alt: "Facebook" },
      ],
    };
  },
  computed: {
    ...mapGetters({ profileData: "getUserProfileData", followData: "getFollowData", loggedIn: "getUserDetails" }),
  },
  created() {
    if (this.profileData) {
      this.linkValue = "https://www.avishkaar.cc/user/" + this.profileData.username;
    }
  },
  mounted() {
    if(this.$route.params.userName != undefined){
      this.accessProfile = false;
      var apiUrl = BASE_URL + "/projects/user/" + this.$route.params.userName; 
    } else {
      var apiUrl = BASE_URL + "/projects/user/";
    }
    axios.get(apiUrl).then(({ data }) => {
      if (data.data) {
        this.projects_data = data.data;
      } else {
        this.projects_data = null;
      }
    });
  },
  methods: {
    ...mapActions(["followUser","UnfollowUser"]),
    Follow() {
      let payload = { username: this.$route.params.userName, type: "follow" };
      this.loading = true;
      this.followUser(payload).then(() => this.loading = false).catch(() => this.loading = false);
    },
    Unfollow() {
      let payload = { username: this.$route.params.userName };
      this.loading = true;
      this.UnfollowUser(payload).then(() => this.loading = false).catch(() => this.loading = false);
    },
    async copyURL(mytext) {
      try {
        await navigator.clipboard.writeText(mytext);
        alert('Copied');
      } catch($e) {
        alert('Cannot copy');
      }
    },
    whatsappShare(linkValue) {
      if(this.$vuetify.breakpoint.width > 700) {
        window.open('https://web.whatsapp.com/send?text=' + linkValue)
      } else {
        window.open('whatsapp://send?text=' + linkValue)
      }
    },
    LinkedInShare(linkValue) {
      window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + linkValue);
    },
    twitterShare(linkValue) {
      if(this.$vuetify.breakpoint.width > 700) {
        window.open('https://twitter.com/intent/tweet?url=' + linkValue)
      } else {
        window.open('twitter://post?message=' + linkValue)
      }
    },
    instagramShare(linkValue) {
      window.open('https://instagram.com/avishkaaredu/');
    },
    gmailShare(linkValue) {
        window.open('https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=Check Out My Profile&body=' + linkValue + '&ui=2&tf=1&pli=1');
    },
    facebookShare(linkValue) {
      if(this.$vuetify.breakpoint.width > 700) {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + linkValue)
      } else {
        window.open('https://m.facebook.com/sharer/sharer.php?u=' + linkValue)
      }
    },
    contactShare(linkValue) {
      window.open('sms:phoneNumber?body=' + linkValue);
    }
  },
};
</script>
<style lang="scss" scoped>
.highlights-container {
  .highlights-container-desktop {
    width: 325px;
    height: 90px;
    z-index: 1;
    position: absolute;
    top: 12%;
    right: 2%;
    background: #ffffff;
    border-radius: 500px;
    box-shadow: 0 0 12px 0 rgb(0, 0, 0, 0.15);
    transition: height 0.1s;
    .highlights-close {
      display: flex;
      align-items: center;
      width: 100%;
      height: 90px;
      border-radius: 500px;
      width: 100%;
      height: 100%;
      .profile-avatar {
        width: 25%;
        .profile-avatar-img {
          border-radius: 50%;
        }
      }
      .profile-name {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 45%;
        .title {
          font-size: 1.25rem;
          color: #505050;
          text-align: left;
          margin: 0.2rem 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .follower {
          font-weight: 500;
          text-align: left;
          margin: 0.2rem 0;
          color: #f3743d;
        }
      }
      .share {
        width: 15%;
        cursor: pointer;
      }
      .dropdown {
        width: 15%;
        cursor: pointer;
      }
    }
    .highlights-open {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 100%;
      border-radius: 40px;
      .profile-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90%;
        // height: 40%;
        height: 45%;
        .profile-avatar-img {
          border-radius: 50%;
        }
      }
      .title {
        font-size: 1.25rem;
        width: 90%;
        height: 7.5%;
        color: #505050;
      }
      .follower {
        width: 90%;
        height: 7.5%;
        font-weight: 500;
        color: #f3743d;
      }
      .project-upload {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 90%;
        // height: 17%;
        height: 19.5%;
        border-top: 1px solid #e1e1e1;
        border-bottom: 1px solid #e1e1e1;
        .count {
          font-family: Poppins;
          font-size: 1.25rem;
          font-weight: 700;
          color: #000000;
          margin: 0.2rem 0;
        }
        .content {
          font-family: Poppins;
          margin: 0.2rem 0;
        }
      }
      .orange-button {
        // height: 10%;
        height: 12.5%;
        margin: 4.5% 0 1% 0;
        width: 90%;
      }
      .white-button {
        background: #ffffff;
        box-shadow: none;
        color: #f36f2e;
        margin: 1% 0 4.5% 0;
      }
      .dropdown {
        position: absolute;
        cursor: pointer;
        width: 25px;
        height: 25px;
        margin-left: 85%;
        margin-top: 9%;
      }
    }
  }
  .highlights-container-desktop-open {
    // height: 550px;
    height: 450px;
    border-radius: 40px;
    box-shadow: 0 0 12px 0 rgb(0, 0, 0, 0.25);
    transition: height 0.3s;
  }
  .highlights-container-mobile {
    display: none;
    border-radius: 50%;
    border: 2px solid #f36f2e;
    box-shadow: 0 7px 10px 0 rgb(0, 0, 0, 0.12);
    border-radius: 50%;
    z-index: 1;
    position: fixed;
    bottom: 10vh;
    width: 75px;
    height: 75px;
    right: 6vw;
    transition: all 0.5s;
  }
}
.dialog-share-container {
  background: #ffffff;
  height: 80vh;
  width: 60vw;
  .title-container {
    display: flex;
    align-items: center;
    height: 12%;
    width: 100%;
    justify-content: space-between;
    padding: 2%;
    box-shadow: 0 1px 8px 0 rgb(0, 0, 0, 0.07);
    .mobile-title {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .back-icon {
        display: none;
        margin-right: 1rem;
      }
      .mobile-title-item {
        display: none;
        margin-top: 3px;
      }
      .title {
        color: #303030;
      }
    }
  }
  .share-container {
    width: 100%;
    height: 70%;
    padding: 2%;
    .or {
      text-align: center;
      margin: 2rem 0;
    }
    .share-via-container {
      display: flex;
      align-items: center;
      width: 100%;
      margin: 1.5rem 0;
      .sub-title {
        text-align: left;
      }
      .share-via {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 70%;
        .share-via-item {
          cursor: pointer;
          .content {
            display: none;
          }
        }
      }
    }
  }
  .footer-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 18%;
    justify-content: center;
    padding: 2%;
    box-shadow: 2px 0 8px 0 rgb(0, 0, 0, 0.07);
    .orange-button {
      width: 40%;
      height: 80%;
    }
  }
}
.curPoi {
  cursor: pointer;
}
.title {
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 600;
  color: #000000;
}
.sub-title {
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 500;
  color: #000000;
}
.content {
  font-family: Roboto;
  font-size: 1rem;
  font-weight: 400;
  color: #000000;
}
.orange-button {
  font-family: Roboto;
  outline: 0;
  font-size: 1rem;
  font-weight: 500;
  background: #f36f2e;
  box-shadow: 0px 2px 2px rgb(0 0 0 / 12%);
  border: 1px solid #f36f2e;
  box-sizing: border-box;
  border-radius: 30px;
  color: white;
}
@media all and (max-width: 1100px) {
  .dialog-share-container {
    width: 80vw;
    .title-container {
      padding: 3.5%;
    }
    .share-container {
      padding: 3.5%;
    }
    .footer-container {
      padding: 3.5%;
      .orange-button {
        height: 90%;
      }
    }
  }
}
@media all and (max-width: 700px) {
  .highlights-container {
    .highlights-container-desktop {
      display: none;
    }
    .highlights-container-mobile {
      display: initial;
      cursor: pointer;
    }
  }
  .highlights-container-mobile-open {
    width: 100vw;
    height: 100vh;
    background: #ffffff;
    .title-container {
      display: flex;
      align-items: center;
      height: 12%;
      width: 100%;
      justify-content: space-between;
      padding: 5%;
      box-shadow: 0 4px 4px 0 rgb(0, 0, 0, 0.03);
      .title {
        color: #303030;
      }
    }
    .highlights {
      height: 73%;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      .profile-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 40%;
        .profile-avatar-img {
          border-radius: 50%;
        }
      }
      .title {
        height: 8%;
      }
      .follower {
        height: 8%;
        font-size: 1rem;
        font-weight: 500;
        color: #f3743d;
      }
      .project-upload {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 80%;
        height: 20%;
        margin: 1rem 0;
        border-top: 1px solid #e1e1e1;
        border-bottom: 1px solid #e1e1e1;
        .count {
          font-family: Poppins;
          font-size: 1.25rem;
          font-weight: 700;
          color: #000000;
          margin: 0.2rem 0;
        }
        .content {
          font-family: Poppins;
          font-size: 1rem;
          margin: 0.2rem 0;
        }
      }
    }
    .footer-container {
      display: flex;
      align-items: center;
      width: 100%;
      height: 15%;
      // justify-content: space-between;
      justify-content: center;
      padding: 5%;
      box-shadow: 0 -4px 4px 0 rgb(0, 0, 0, 0.03);
      .orange-button {
        // width: 48%;
        width: 96%;
        height: 80%;
      }
      .white-button {
        background: #ffffff;
        box-shadow: none;
        color: #f36f2e;
      }
    }
  }
  .dialog-share-container {
    width: 100vw;
    height: 100vh;
    .title-container {
      padding: 5%;
      .mobile-title {
        .back-icon {
          display: initial;
        }
        .mobile-title-item {
          font-family: Poppins;
          font-size: 1.25rem;
          font-weight: 600;
          color: #303030;
          display: initial;
        }
        .title {
          display: none;
        }
      }
    }
    .share-container {
      height: 73%;
      padding: 5%;
      .share-via-container {
        margin: 1rem 0;
        .sub-title {
          display: none;
        }
        .share-via {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          width: 100%;
          .share-via-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 21%;
            flex-basis: 25%;
            .share-via-img {
              margin-top: 1rem;
            }
            .content {
              display: inherit;
              font-weight: 500;
              margin: 0.5rem 0;
              font-size: 0.75rem;
              color: #303030;
            }
          }
        }
      }
    }
    .footer-container {
      height: 15%;
      padding: 5%;
      .orange-button {
        width: 100%;
        height: 75%;
      }
    }
  }
  .title {
    font-size: 1.25rem;
  }
  .sub-title {
    font-size: 1rem;
  }
  .content {
    font-size: 0.875rem;
  }
}
.loaderr {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  z-index: 9999;
  width: 100vw;
  background-color: rgb(0, 0, 0, 0.5);
  position: fixed;
}
.loader3 {
   width:50px;
   height:50px;
   display:inline-block;
   padding: 0px;
   margin-bottom: 64px;
   text-align:left;
}
.loader3 span {
   position:absolute;
   display:inline-block;
   width:50px;
   height:50px;
   border-radius:100%;
   background:rgba(135, 211, 124,1);
   -webkit-animation:loader3 1.5s linear infinite;
   animation:loader3 1.5s linear infinite;
}
.loader3 span:last-child {
   animation-delay:-0.9s;
   -webkit-animation-delay:-0.9s;
}
@keyframes loader3 {
   0% {transform: scale(0, 0);opacity:0.8;}
   100% {transform: scale(1, 1);opacity:0;}
}
@-webkit-keyframes loader3 {
   0% {-webkit-transform: scale(0, 0);opacity:0.8;}
   100% {-webkit-transform: scale(1, 1);opacity:0;}
}
</style>
<style lang="scss">
.dialog-share-container {
  .share-container {
    .link-people {
      .input-search {
        color: #f36f2e;
        border-radius: 10px;
        .theme--light.v-label--active {
          font-family: Roboto;
          font-size: 1rem;
          font-weight: 400;
          color: #aaaaaa;
          top: 15px;
          left: -5px !important;
        }
        .theme--light.v-label--active.primary--text {
          color: #f36f2e;
        }
        input {
          font-family: Roboto;
          font-size: 1.125rem;
          font-weight: 400;
          color: #000000;
        }
      }
      .v-input__prepend-inner {
        margin: auto 0.6rem auto 0;
      }
      .v-text-field--outlined legend {
        margin-left: 0.4rem;
      }
    }
    .link-input {
      margin-top: 1.5rem;
      .input-share {
        color: #aaaaaa;
        border-radius: 10px;
        .theme--light.v-label--active {
          font-family: Roboto;
          font-size: 1rem;
          font-weight: 400;
          color: #aaaaaa;
          top: 15px;
        }
        input {
          font-family: Roboto;
          font-size: 1.125rem;
          font-weight: 400;
          color: #000000;
        }
      }
      .v-text-field--outlined legend {
        margin-left: 0.7rem;
      }
    }
  }
}
</style>